/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Tag } from '../models/Tag';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompositeTagService {

    /**
     * Add tags to composites
     * @returns Tag Success
     * @throws ApiError
     */
    public static assignCompositeTags({
        requestBody,
    }: {
        requestBody: {
            tags: any[];
            compositeIds: any[];
            replace?: boolean;
        },
    }): CancelablePromise<Array<Tag>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/composite/tag',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
